import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo";
import TermsPage from "@/pages/legal/Terms";

export const Route = createFileRoute("/$lang/conditions")({
  head: ({ params }) => pageHead(params.lang, "terms"),
  component: TermsPage,
});
